export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Besoin de nous parler ?"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["On vous répond rapidement."])},
        "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contacter Estaly"])},
        "image_alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Support Estaly"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Need to talk to us?"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We answer quickly."])},
        "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact Estaly"])},
        "image_alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estaly support"])}
      }
    }
  })
}
